export default __webpack_public_path__ + "static/media/hht1_ep08_timeline_08.b24567b0.png";